import { Endpoint } from '../endpoint';

export const ReferenceListUsageView = new Endpoint('reference_list_usage_view');
